import React from 'react';
import { AutoBind } from './lib/prevalent';
import './css/style.css';
import button_submit_arrow from './img/button_submit_arrow.svg';

export default class Page extends React.Component {
    constructor(props) {
        super(props);
        AutoBind(this);
        this.state = {
            showCopied: false, copied: false
        };
    }

    SetRef(el) {
        this.InputRef = el;
    }

    onClickShowHideCopied() {
        this.InputRef.select();
        document.execCommand("copy");
        this.InputRef.setSelectionRange(0, 0);
        this.setState({ showCopied: true, copied: true });
        let timer = setTimeout(() => {
            this.setState({ showCopied: false });
            clearTimeout(timer);
        }, 2000)
    }

    onClickGo() {
        if (this.state.copied) {
            window.location.href = 'https://fridn.com/';
        }
    }

    render() {
        const state = this.state;
        const aitxt = this.props.aitxt;
        return (
            <div className="s2_group">
                <p className="s2_group_title">
                    <span>{aitxt[16]}</span>
                </p>
                <div className="wrapper">
                    <div className="wrap wrap-1">
                        <div className="field">
                            <p className="field_title light">{aitxt[17]}</p>
                            <div className="copy_input_wrap">
                                <input type="text" className="field_input" readOnly value="0xd6cbdea946605742d148b9d95a51f4d14c926ef1"
                                    ref={this.SetRef} />
                                <p onClick={this.onClickShowHideCopied} className={state.showCopied ? 'copy_message active' : 'copy_message'}>
                                    {state.showCopied ? 'Copied' : 'Copy'}</p>
                            </div>
                        </div>
                    </div>

                    <ul className="instruction">
                        <li className="instruction_item">{aitxt[18]}</li>
                        <li className="instruction_item">{aitxt[19]}</li>
                        <li className="instruction_item">{aitxt[20]}
                            <span>{aitxt[21]}</span>
                        </li>
                        <li className="instruction_item">{aitxt[22]}</li>
                        <li className="instruction_item">{aitxt[23]}</li>
                    </ul>
                    <div className="commission">
                        <span className="commission_alert">{aitxt[24]}</span>
                        <p className="commission_desc">{aitxt[25]}<br />
                            {aitxt[26]}<br />
                            {aitxt[27]}<br />
                            {aitxt[28]}
                        </p>
                    </div>
                    {
                        /*<div className="info">
                            <div className="checkbox">
                                <input type="checkbox" className="check_info" id="checkbox_2" />
                                <label className="check_info_label" htmlFor="checkbox_2">I read terms&conditions</label>
                            </div>
                        </div>*/
                    }

                    <div className="buttons_block">
                        <button className={state.copied ? 'button button_go_to' : 'button button_go_to buttongray'}
                            onClick={this.onClickGo}>{aitxt[30]}
                            <span><img src={button_submit_arrow} alt="go" /></span>
                        </button>
                    </div>
                    <br />
                    <p className="field_title">
                        {aitxt[29]}
                    </p>
                </div>
            </div>
        );
    }
}
